import { render, staticRenderFns } from "./SButtonPaiement.vue?vue&type=template&id=3e293bf4&"
import script from "./SButtonPaiement.vue?vue&type=script&lang=js&"
export * from "./SButtonPaiement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports